var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 81"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M74.81 51.316c-4.238-4.238-7.588-9.39-7.588-15.383v-8.141a26.667 26.667 0 1 0-53.333 0v8.141c0 5.993-3.35 11.145-7.587 15.383a4.445 4.445 0 0 0 3.142 7.587h62.223a4.445 4.445 0 0 0 3.142-7.587Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M41.25 80.5c2.65.002 5.254-.69 7.55-2.007A15.045 15.045 0 0 0 54.325 73a4.978 4.978 0 0 0 0-5 5.015 5.015 0 0 0-1.84-1.83 5.052 5.052 0 0 0-2.515-.67H32.529c-.883 0-1.75.231-2.514.67A5.015 5.015 0 0 0 28.174 68a4.977 4.977 0 0 0 0 5 15.045 15.045 0 0 0 5.527 5.493A15.156 15.156 0 0 0 41.25 80.5Z",
    opacity: 0.4
  })));
};
export default SvgAlert;